import { uncurry } from "../Docs/fable_modules/fable-library.3.7.1/Util.js";
import { Aggregation, AggregationFnOption$1 } from "./Types.fs.js";
import { map } from "../Docs/fable_modules/fable-library.3.7.1/Option.js";
import { toString } from "../Docs/fable_modules/fable-library.3.7.1/Types.js";
import { class_type } from "../Docs/fable_modules/fable-library.3.7.1/Reflection.js";

function objToAggregation(agg) {
    let matchValue;
    if ((typeof agg === 'function')) {
        return new AggregationFnOption$1(1, uncurry(2, agg));
    }
    else {
        return map((arg0_1) => (new AggregationFnOption$1(0, arg0_1)), (matchValue = toString(agg), (matchValue === "sum") ? (new Aggregation(0)) : ((matchValue === "min") ? (new Aggregation(1)) : ((matchValue === "max") ? (new Aggregation(2)) : ((matchValue === "extent") ? (new Aggregation(3)) : ((matchValue === "mean") ? (new Aggregation(4)) : ((matchValue === "median") ? (new Aggregation(5)) : ((matchValue === "unique") ? (new Aggregation(6)) : ((matchValue === "uniqueCount") ? (new Aggregation(7)) : ((matchValue === "count") ? (new Aggregation(8)) : ((matchValue === "auto") ? (new Aggregation(9)) : (void 0))))))))))));
    }
}

export class Column {
    constructor() {
    }
}

export function Column$reflection() {
    return class_type("Feliz.TanStack.Table.Grouping.Column", void 0, Column);
}

export function Column_aggregationFn_Z2685F962(column) {
    return objToAggregation(column.aggregationFn);
}

export function Column_getCanGroup_Z2685F962(column) {
    return column.getCanGroup();
}

export function Column_getIsGrouped_Z2685F962(column) {
    return column.getIsGrouped();
}

export function Column_getGroupedIndex_Z2685F962(column) {
    return column.getGroupedIndex();
}

export function Column_toggleGrouping_Z2685F962(column) {
    if (Column_getCanGroup_Z2685F962(column)) {
        column.toggleGrouping();
    }
}

export function Column_getAutoAggregationFn_Z2685F962(column) {
    return objToAggregation(column.getAutoAggregationFn());
}

export function Column_getAggregationFn_Z2685F962(column) {
    return objToAggregation(column.getAggregationFn());
}

export class Row {
    constructor() {
    }
}

export function Row$reflection() {
    return class_type("Feliz.TanStack.Table.Grouping.Row", void 0, Row);
}

export function Row_getIsGrouped_773C3262(row) {
    return row.getIsGrouped();
}

export class Table {
    constructor() {
    }
}

export function Table$reflection() {
    return class_type("Feliz.TanStack.Table.Grouping.Table", void 0, Table);
}

export function Table_setGrouping(grouping, table) {
    table._obj.setGrouping(grouping);
    return table;
}

export function Table_resetGrouping(defaultValue, table) {
    table._obj.resetGrouping(defaultValue);
    return table;
}

export function Table_getPreGroupedRowModel_Z4395D14A(table) {
    return table._obj.getPreGroupedRowModel();
}

export function Table_getGroupedRowModel_Z4395D14A(table) {
    return table._obj.getGroupedRowModel();
}

export class Cell {
    constructor() {
    }
}

export function Cell$reflection() {
    return class_type("Feliz.TanStack.Table.Grouping.Cell", void 0, Cell);
}

export function Cell_getIsGrouped_Z78EF7AD2(cell) {
    return cell.getIsGrouped();
}

export function Cell_getIsAggregated_Z78EF7AD2(cell) {
    return cell.getIsAggregated();
}

export function Cell_getIsPlaceholder_Z78EF7AD2(cell) {
    return cell.getIsPlaceholder();
}

//# sourceMappingURL=Grouping.fs.js.map
